import axios from "axios";
import { adminApiUrl, publicApiUrl } from "../util/Constants";

const ADMINISTRATION_API = "/administration";

export const adminApi = {
  getGenericInput: async (id: string): Promise<string> => {
    const { data } = await axios.get<string>(`${publicApiUrl}${ADMINISTRATION_API}/generic-input/${id}`);
    return data;
  },

  createOrUpdateGenericInput: async ({ id, content }: { id: string; content: string }): Promise<unknown> => {
    const { data } = await axios.post(`${adminApiUrl}${ADMINISTRATION_API}/generic-input`, { id, content });
    return data;
  },
};
